import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import defaultBookImage from "../assets/default-book-image.png";
import {BottomNavigation, BottomNavigationAction, Chip, Fab} from "@mui/material";
import Modal from "@mui/material/Modal";
import {Fade} from "reactstrap";
import Loading from "./Loading";

class BookModal extends Component {

    render() {
        // Parent Variables
        let book = this.props.book || null;
        let loadingUpdate = this.props.loadingUpdate || false;

        // Parent Functions
        const showBookModal = this.props.showBookModal;
        const closeBookModal = this.props.closeBookModal;
        const bookModalNavValue = this.props.bookModalNavValue;
        const setBookModalNavValue = this.props.setBookModalNavValue;
        const markAsReading = this.props.markAsReading;
        const markAsNotReading = this.props.markAsNotReading;
        const markCompleted = this.props.markCompleted;
        const openConfirmDialog = this.props.openConfirmDialog;


        const getAuthors = (authors) => {
            if (authors) {
                return authors.join(", ");
            }
            return "Unknown";
        }

        const showUpdateButtons = () => {
            return bookModalNavValue === "update";
        }

        const isReading = (book) => {
            return book.currentlyReading;
        }

        const hasCompleted = (book) => {
            return book.completed;
        }

        return (
            <Modal
                open={showBookModal}
                onClose={closeBookModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className={"book-modal"}
            >
                <div className="book-modal-inner">

                    {loadingUpdate &&
                        <div className="loading-update-container">
                            <Loading/>
                        </div>
                    }

                    <div className="book-modal-close">
                        <button onClick={closeBookModal}>
                            <FontAwesomeIcon icon="times"/>
                        </button>
                    </div>

                    {(book) &&
                        <>
                            <div className="book-details">

                                <div className="image">

                                    <div className="book-status">
                                        {isReading(book) &&
                                            <Chip label="Reading" className="reading-chip"/>
                                        }

                                        {hasCompleted(book) &&
                                            <Chip label="Completed" className="completed-chip"/>
                                        }
                                    </div>

                                    {book.coverData ?
                                        <img
                                            src={book.coverData}
                                            alt={book.book.title}
                                            width="100%"
                                            height="auto"/>
                                        :
                                        <img
                                            src={defaultBookImage}
                                            alt="Default book cover"
                                            width="100%"
                                            height="auto"/>
                                    }
                                </div>


                                <div className="info">
                                    <div className="title">
                                        <span>{book.book.title}</span>
                                    </div>
                                    <div className="author">
                                        {getAuthors(book.book.author_name)}
                                    </div>
                                    <div className="first-published">
                                        {book.book.first_publish_year}
                                    </div>
                                    {(book.book.subject?.length > 0) &&
                                        <div className="categories">
                                            {book.book.subject.map((category, index) => {
                                                return (
                                                    <Chip key={index} label={category}
                                                          className="category-chip"/>
                                                );
                                            })}
                                        </div>
                                    }

                                </div>
                            </div>

                            <div className="update-actions">
                                <Fade in={showUpdateButtons()}>
                                    <>
                                        {(!isReading(book) && !hasCompleted(book)) &&
                                            <Fab
                                                variant="extended"
                                                size="small"
                                                className="mark-as-reading fab"
                                                onClick={() => {
                                                    markAsReading(book.book);
                                                    setBookModalNavValue("details");
                                                }}
                                            >
                                                <FontAwesomeIcon icon="book-open"/>
                                                <span>Reading</span>
                                            </Fab>
                                        }

                                        {(isReading(book) || hasCompleted(book)) &&
                                            <Fab
                                                variant="extended"
                                                size="small"
                                                className="mark-as-unread fab"
                                                onClick={() => {
                                                    markAsNotReading(book.book);
                                                    setBookModalNavValue("details");
                                                }}
                                            >
                                                <FontAwesomeIcon icon="book"/>
                                                {isReading(book) && <span>Not Reading</span>}
                                                {hasCompleted(book) && <span>Not Completed</span>}
                                            </Fab>
                                        }

                                        {!hasCompleted(book) &&
                                            <Fab
                                                variant="extended"
                                                size="small"
                                                className="mark-as-completed fab"
                                                onClick={() => {
                                                    markCompleted(book.book);
                                                    setBookModalNavValue("details");
                                                }}
                                            >
                                                <FontAwesomeIcon icon="check"/>
                                                <span>Completed</span>
                                            </Fab>
                                        }
                                    </>
                                </Fade>
                            </div>

                            <div className="book-actions">
                                <BottomNavigation value={bookModalNavValue} onChange={(event, newValue) => {
                                    if (bookModalNavValue === "update") {
                                        setBookModalNavValue("details");
                                    } else {
                                        setBookModalNavValue(newValue);
                                    }
                                }}>
                                    <BottomNavigationAction
                                        label="Update"
                                        value="update"
                                        icon={<FontAwesomeIcon icon="bars"/>}
                                    />
                                    <BottomNavigationAction
                                        className="delete-book-button"
                                        label=""
                                        value="delete"
                                        icon={<FontAwesomeIcon icon="trash"/>}
                                        onClick={(event) => {
                                            openConfirmDialog(book.book, event)
                                        }}
                                    />
                                </BottomNavigation>
                            </div>

                        </>
                    }
                </div>
            </Modal>
        );
    }

}


export default BookModal;
